import inventoryApi from '../../../core/apis/inventoryApi';
import { useGetFetchInventoryStatusPayload, DEALER_INVENTORY_ENDPOINT, } from '../../../core/apiHooks/useFetchInventoryStatus';
import { useAppSelector } from '../../../core/utils';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import { isAvailable } from './useInventoryStatusChange';
/**
 * query cached inventory status data, will not trigger new request
 *
 */
const useGetPreviousInventoryStatus = () => {
    const { url, headers, params } = useGetFetchInventoryStatusPayload();
    const { data: previousStatusData, isUninitialized } = inventoryApi.endpoints.getModelInventoryStatus.useQueryState({
        url: `${url}/${DEALER_INVENTORY_ENDPOINT}`,
        headers,
        params,
        shouldResetStatus: true,
    }, {
        skip: !params.dealerCodes || !params.modelCodes || !params.extColors || !url,
    });
    // when previous request was already cached, keep subscription alive but skip sending new one
    inventoryApi.endpoints.getModelInventoryStatus.useQuerySubscription({
        url: `${url}/${DEALER_INVENTORY_ENDPOINT}`,
        headers,
        params,
        shouldResetStatus: true,
    }, {
        skip: isUninitialized,
    });
    const { inventoryStatus } = useAppSelector(selectCurrentVehicle);
    return {
        isPreviousStatusCached: !!previousStatusData,
        previousStatus: isAvailable(inventoryStatus) ? inventoryStatus : undefined,
    };
};
export default useGetPreviousInventoryStatus;
